import styled from "styled-components";

export const ContentMobile = styled.div`
  width: 390px;
  margin: 0 auto;
  @media (min-width: 768px) {
  width: fit-content;
display: none;

  }
`

export const Content = styled.div`
  width: 390px;
  margin: 0 auto;

  display: none;
  @media (min-width: 768px) {
  width: fit-content;
  display: block;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  padding: 16px ;
  height: fit-content;

  img {
    max-width: clamp(220px, 32vw, 420px);
    height: auto;
    flex-shrink: 0;
    border-radius: 12px;
    margin-top: 8px;
  }

   @media (min-width: 768px) {
    flex-direction: row;
    gap: 64px;
    justify-content: center;
    padding: 24px;
    height: 60vh;
   }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(520px, 80%);
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;

  @media (max-width: 767px) {
    width: 100%;
    font-size: 15px;
    line-height: 22px;
  }

  @media (min-width: 768px) { text-align: left; }

  h3 { font-size: clamp(20px, 3vw, 32px); font-weight: 550; line-height: 1.25; }

  ul {
    list-style: none;
    display: flex; 
    flex-direction: column; 
    gap: 4px;
  }

  li{
   display: flex;
    justify-content:center ;
   gap:4px;

   span{
    text-align: left;
   }
  }

  @media (min-width: 768px) { 
    li{
      justify-content:flex-start ;
    }
  }
`;
